export default __webpack_public_path__ + "static/media/ProductSans-Bold.95e000cd.eot";